import React from "react";
import {formatNumber} from "../../utils/number";
import {getTextColorByROI, shortAddress, getHpChest, getTextColorByHpChest} from "../../utils/text";
import {dateFormat, timeFromNow} from "../../utils/time";
import {deleteAccount} from "../../store/account";
import {useDispatch} from "react-redux";

/**
 * @return {null}
 */
function Result(props) {
    const {data} = props;
    const dispatch = useDispatch();

    const deleteAccountFromList = (id) => {
        dispatch(deleteAccount(id));
    };

    if (data) {

        let roi = null;
        if (data.funding > 0) {
            roi = (data.amount_of_bcoin) / data.funding * 100;
        }

        return (
            <>
                <div className={"col-md-6 mb-4"}>
                    <div className="item-card card card-cascade wider">
                        <div className="view view-cascade grey darken-3">
                            <div className="m-3 small">

                                <div className="delete" onClick={() => deleteAccountFromList(data.address)}>
                                    <div className="small">X</div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <div className="small"> Address</div>
                                        <h5>  {shortAddress(data.address.toUpperCase())} </h5>
                                    </div>

                                    <div className="col">
                                        <div className="small"> Funding</div>
                                        <h5>
                                            {data.funding ? formatNumber(data.funding, 0, 0) + " BCOIN" : "N/A"}
                                        </h5>
                                    </div>

                                    <div className="col-6">
                                        <div className="small"> ROI</div>
                                        <h5 className={getTextColorByROI(roi)}>  {roi ? formatNumber(roi) + "%" : "N/A"} </h5>
                                    </div>


                                    <div className="col-6">
                                        <div className="small"> Total Claimed</div>
                                        <h5>
                                            {data.amount_of_bcoin ? formatNumber(data.amount_of_bcoin) + " BCOIN" : "N/A"}
                                        </h5>
                                    </div>

                                    <div className="col">
                                        <div className="small"> Heroes</div>
                                        <h5>
                                            {data.heroes.every(h => h.value === 0) && <div> N/A </div>}
                                            {data.heroes.length > 0 && data.heroes.map((h, index) => {
                                                if (h.value > 0) {
                                                    return <span className={h.name}
                                                                 key={index}> {h.value}{h.name}</span>
                                                }
                                            })}
                                        </h5>
                                    </div>
                                </div>

                                <hr className="mt-0 mb-2"/>

                                <div className="row justify-content-end">
                                    <div className="col-auto">
                                        <div className="small"> Claimed Amount ({data.items.length})</div>
                                    </div>
                                </div>

                                {data.items.length > 0 &&
                                <div className="row" style={{height: "80px", overflow: "auto"}}>
                                    <div className="col">

                                        <table className="claim table table-borderless text-white">
                                            <tbody>
                                            {data.items.map(item => {
                                                return <tr key={item.request_id}>
                                                    <td>
                                                        <a className="text-white text-nowrap" target="_blank"
                                                           href={"https://bscscan.com/tx/" + item.tx_hash}> {shortAddress(item.tx_hash)} </a>
                                                    </td>
                                                    <td>
                                                        {dateFormat(item.claimed_at)}
                                                    </td>
                                                    <td>
                                                        {timeFromNow(item.claimed_at)}
                                                    </td>
                                                    <td className="text-right">
                                                        {formatNumber(item.amount)}
                                                    </td>
                                                </tr>
                                            })}
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                                }


                                {data.items.length === 0 &&
                                <div className="row align-items-center justify-content-center"
                                     style={{height: "80px", overflow: "auto"}}>
                                    <div className="col-auto">
                                        <h5> NOT FOUND DATA </h5>
                                    </div>
                                </div>
                                }


                            </div>
                        </div>
                    </div>
                </div>
            </>
        );

    } else {
        return null;
    }


}

export default Result;
